import { computed, inject, Injectable } from '@angular/core';
import { EAccessCode } from '@app/app.enums';
import { selectAuth } from '@app/features/auth/auth.selectors';
import { Store } from '@ngrx/store';

export const CREATE_SB_ACCESS = [
  EAccessCode['c_InitiatingSituation.cf_SbInsert'],
] as const;

@Injectable({ providedIn: 'root' })
export class AppCapabilityService {
  private readonly auth = inject(Store).selectSignal(selectAuth);

  public readonly ready = computed(
    () => this.auth().init && this.auth().accessStatus === 'ready',
  );
  public readonly canCreateSb = computed(() =>
    this.hasSomeAccess(CREATE_SB_ACCESS),
  );
  public readonly canCreateNnr = computed(() =>
    this.hasAccess(EAccessCode['c_InitiatingSituation.cf_NnrInsert']),
  );
  public readonly canCreateEvent = computed(
    () => this.canCreateSb() || this.canCreateNnr(),
  );

  private hasAccess(accessCode: EAccessCode): boolean {
    return this.ready() && this.auth().access.includes(accessCode);
  }

  private hasSomeAccess(accessCodes: readonly EAccessCode[]): boolean {
    return (
      this.ready() &&
      accessCodes.some((accessCode) => this.auth().access.includes(accessCode))
    );
  }
}
